import React from 'react';
import './SkillSlider.css';





const SkillSlider = ({img, name, percent}) => {
    

    return (
        <div class="skill">
            <img class="skill-logo" src={img} />
            <div class="slider">
                <div class="outer">
                    <div class="inner" style={{width: percent}}/>
                </div>
                <h4>{name}</h4>
            </div>
        </div>
    )
}

export default SkillSlider;